import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalDm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMd: 'bx--modal bx--modal bx--modal-tall is-visible',
      hiddenMd: 'bx--modal bx--modal',
      // open: true,
    };
  }

  static propTypes = {
    // openModal: PropTypes.func,
    hiddenModal: PropTypes.func,
  };

  static defaultProps = {
    // openModal: obj => null,
    hiddenModal: () => null,
  };

  render() {
    const { showMd, hiddenMd } = this.state;
    const { heading, openMd, hiddenModal, children, className, modalWidth } = this.props;

    return (
      <div>
        <div data-modal id="modal-igekmqme1k" className={(openMd ? showMd : hiddenMd) + (className ? ` ${className}` : '')}>
          <div className={`bx--modal-container md--modal-container border-new-color ${modalWidth ? modalWidth : ''}`}>
            <div className="bx--modal-header">
              <p className="bx--modal-header__heading bx--type-beta">{heading}</p>
              <button
                onClick={hiddenModal}
                className="bx--modal-close"
                type="button"
                data-modal-close
                aria-label="close modal"
              >
                <svg
                  className="bx--modal-close__icon"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Fechar Modal</title>
                  <path d="M6.32 5L10 8.68 8.68 10 5 6.32 1.32 10 0 8.68 3.68 5 0 1.32 1.32 0 5 3.68 8.68 0 10 1.32 6.32 5z" />
                </svg>
              </button>
            </div>
            {children}
          </div>
        </div>
      </div>
    );
  }
}
export default ModalDm;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalDm.js